import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';

// Shown in place of a page that's temporarily taken down for maintenance.
// Rendered *inside* ProtectedRoute/AppLayout (see App.js), so the Navbar
// (and its other tabs) and the app footer stay on screen — only the content
// area is replaced. Kept generic (title/message props) so it can be reused
// for other pages without copy-pasting the layout.
export default function Maintenance({
  title = 'Dashboard under maintenance',
  message = "We're making some improvements behind the scenes. The dashboard will be back shortly — thanks for your patience. The rest of MarketNerve is up as usual — use the tabs above to keep going.",
}) {
  const { colors, fonts, nerveRgb } = useTheme();
  const C = colors;
  const F = fonts;

  return (
    <div style={{
      maxWidth: '560px', margin: '0 auto', padding: '5rem 1.5rem 6rem',
      display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center',
    }}>
      <div style={{
        width: '64px', height: '64px', borderRadius: '50%',
        background: `rgba(${nerveRgb},0.1)`, border: `1px solid rgba(${nerveRgb},0.25)`,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        marginBottom: '1.75rem', color: C.action,
      }}>
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" />
        </svg>
      </div>

      <div style={{
        display: 'inline-flex', alignItems: 'center',
        background: `rgba(${nerveRgb},0.08)`, border: `1px solid ${C.border}`,
        borderRadius: '2rem', padding: '0.4rem 1.125rem', marginBottom: '1.5rem',
        fontSize: '0.68rem', fontFamily: F.display, fontWeight: 700,
        letterSpacing: '0.12em', textTransform: 'uppercase', color: C.action,
      }}>
        Scheduled Maintenance
      </div>

      <h1 style={{ fontSize: 'clamp(1.75rem, 4vw, 2.5rem)', fontWeight: 800, letterSpacing: '-0.03em', fontFamily: F.display, color: C.text, marginBottom: '1rem' }}>
        {title}
      </h1>
      <p style={{ color: C.textMuted, fontSize: '0.95rem', lineHeight: 1.75, fontFamily: F.body, marginBottom: '2.5rem' }}>
        {message}
      </p>

      <Link to="/watchlist" style={{
        background: C.action, color: '#fff',
        padding: '0.75rem 2rem', borderRadius: '0.625rem', textDecoration: 'none',
        fontWeight: 700, fontSize: '0.9rem', fontFamily: F.display,
      }}>
        Go to Watchlist
      </Link>

      <p style={{ color: C.textMuted, fontSize: '0.8rem', marginTop: '2.5rem', fontFamily: F.body }}>
        Questions? Reach us at{' '}
        <a href="mailto:marketnervehq@gmail.com" style={{ color: C.action, textDecoration: 'none' }}>marketnervehq@gmail.com</a>
      </p>
    </div>
  );
}
